import axios from '../axios'

var AxleCounterProvider = function () {
  return {
    async GetLogbookByRailobjectId (railobjectid, startFrom, nrOfRows) {
      return axios.get('/axlecountert/logbook/' + railobjectid + '/' + startFrom + '/' + nrOfRows)
    },
    async GetZprStateByRailobjectId (railobjectid, startFrom, nrOfRows) {
      return axios.get('/axlecountert/zprstate/' + railobjectid + '/' + startFrom + '/' + nrOfRows)
    },
    async GetMeasurementByRailobjectid (railobjectid, startFrom, nrOfRows) {
      return axios.get('/axlecountert/measurement/' + railobjectid + '/' + startFrom + '/' + nrOfRows)
    },
    async GetAlarmSettingsByRailobjectid (railobjectid, startFrom, nrOfRows) {
      return axios.get('/axlecountert/alarmsettings/' + railobjectid + '/' + startFrom + '/' + nrOfRows)
    }
  }
}
export default new AxleCounterProvider()



// WEBPACK FOOTER //
// ./src/providers/AxleCounterProvider.js